import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';
import DatePresenter from '../../presenters/DatePresenter';
import { amountReadable } from '../../utils/functions';

const WELCOME = 'welcome';
const REFERRAL = 'referral';

export const TYPES = [WELCOME];

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    bonusType: PropTypes.string,
    state: PropTypes.string,
    createdAt: PropTypes.string,
    amount: PropTypes.number,
    membershipId: PropTypes.string,
  },
  {
    createdAtReadable(bonus) {
      const createdAt = this.createdAt(bonus);
      return DatePresenter.shortFormattedDate(createdAt);
    },
    typeReadable(bonus) {
      const typeMap = {
        [WELCOME]: 'Welcome',
        [REFERRAL]: 'Referral',
      };
      const type = this.bonusType(bonus);

      return typeMap[type];
    },
    amountReadable(bonus) {
      const amount = this.amount(bonus);

      return amountReadable(amount);
    },
  }
);
